module.exports = __webpack_public_path__ + "static/logo-56f794ce801503ea1bec9ed079e1d427.png";